<script>
import _ from 'lodash';
import responsiveMixin from '@/mixins/responsiveMixin';
import { protectedRoutes } from '@/router/routes';

export default {
  mixins: [responsiveMixin],
  data: () => ({
    loginLinks: [
      { text: 'Participant', href: '/respondents/v2/login' },
      { text: 'Researcher', href: '/login' },
    ],
    logoutLink: { text: 'Log Out', href: '/logout' },
  }),
  computed: {
    isLoggedIn() {
      return _.includes(protectedRoutes, this.$route.name);
    },
  },
};
</script>

<template>
  <div>
    <v-btn v-if="isLoggedIn" color="primary" text :href="logoutLink.href">
      {{ logoutLink.text }}
    </v-btn>

    <template v-else>
      <span v-if="!isMobile" class="fs-14">Already have an account?</span>

      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="primary" text v-bind="attrs" v-on="on">
            Log In
            <v-icon right> fas fa-caret-down </v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="link in loginLinks"
            :key="`${link.text}-login-link`"
            link
            :href="link.href"
          >
            <v-list-item-title> {{ link.text }} Login </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
  </div>
</template>
